export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";